import storageService from '../storageService';
import {PublicMediaLinkService} from './restServices';

const service = {};

service.createPublicMediaLink = async (chatMessageId) => {
  const response = await PublicMediaLinkService.save(
    {
      endpoint: '',
    },
    {
      chatMessageId,
      token: storageService.getItem('token'),
    },
  );
  return response.data.publicMediaLinkDto;
};

service.getPublicMediaLink = async (publicMediaAccessString) => {
  const response = await PublicMediaLinkService.get({
    endpoint: publicMediaAccessString,
    endpointParam: '',
  });
  return response.data;
};

const publicMediaLinkService = {...service};
export default publicMediaLinkService;
